import React, { useState, useEffect } from "react";

function RecentTransactions() {
  return (
    <div className="flex flex-col w-full p-5 mt-5 border h-96 border-b-400 min-w-min"></div>
  );
}

export default RecentTransactions;
